module.exports = __webpack_public_path__ + "static/SW0-d4c75e2c006100f9582f0a5a462b8578.png";